import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { useAuthStore } from '../../../stores/authStore';
import type { LoginRequest } from '../../../types';

const loginSchema = z.object({
  username: z.string().min(1, '请输入邮箱或用户名'),
  password: z.string().min(6, '密码至少6位'),
});

export const LoginForm: React.FC = () => {
  const { login, isLoading, error } = useAuthStore();
  
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<LoginRequest>({
    resolver: zodResolver(loginSchema)
  });

  const onSubmit = async (data: LoginRequest) => {
    try {
      await login(data);
    } catch (error) {
      // 错误已经在store中处理
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <Input
        label="邮箱或用户名"
        placeholder="请输入邮箱或用户名"
        error={errors.username?.message}
        {...register('username')}
      />
      
      <Input
        label="密码"
        type="password"
        placeholder="请输入密码"
        error={errors.password?.message}
        {...register('password')}
      />
      
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-600">{error}</p>
        </div>
      )}
      
      <Button
        type="submit"
        loading={isLoading}
        className="w-full"
        variant="primary"
      >
        登录
      </Button>
    </form>
  );
};